<div class="card-container">
  <!-- Left Side: Image -->
  <a class="card-image" href="{{ newsItem.UrlLink }}" target="_blank">
    <img [src]="newsItem.imageSrc" alt="newsItem.Title" />
  </a>

  <!-- Right Side: Content -->
  <div class="card-content">
    <div class="card-header-content">
      <div class="card-title">
        {{ newsItem.Title }}
      </div>
      <div class="card-details" *ngIf="newsItem.Details">
        {{ newsItem.Details }}
      </div>
    </div>

    <div class="card-footer">
      <!-- Date Format: May 25, 2025, 14:00 -->
      <span class="card-date">
        {{ newsItem.CreatedAt | date: 'MMM d, y, HH:mm' }}
      </span>

      <!-- Arrow Button -->
      <a class="arrow-btn" href="{{ newsItem.UrlLink }}" target="_blank">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 5L19 12L12 19" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </div>
  </div>
</div>
